import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { CaretRight, ChartLineUp, Users, Target } from '@phosphor-icons/react';
import './Hero.css';

const projects = [
  {
    id: 1,
    title: "GEN Rentals",
    subtitle: "#1 Generator Rental Provider",
    image: "/projects/project1.png"
  },
  {
    id: 2,
    title: "VFINAX Tax Consultant",
    subtitle: "Professional Accounting Ally",
    image: "/projects/project2.png"
  },
  {
    id: 3,
    title: "FVAGITO Dining",
    subtitle: "Elevating Dining Experience",
    image: "/projects/project3.png"
  },
  {
    id: 4,
    title: "Nutsby Fitness",
    subtitle: "Premium Supplements Store",
    image: "/projects/project4.png"
  }
];

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isMaximized, setIsMaximized] = useState(false);

  useEffect(() => {
    if (!isMaximized) {
      const timer = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % projects.length);
      }, 5000);
      return () => clearInterval(timer);
    }
  }, [isMaximized]);

  const toggleMaximize = () => {
    setIsMaximized(!isMaximized);
  };

  return (
    <section className="hero">
      <Container>
        <Row className="align-items-center">
          <Col lg={7} className="hero-left">
            <h1 className="hero-title">
              <span>Custom Web App</span> Development Services for<br />
              <span className="accent-text">Scalable Growth</span>
            </h1>
            
            <p className="hero-description">
              At Cabptoid, we build high-performance, secure, and scalable web<br />
              applications tailored to your business goals. From dynamic portals to<br />
              enterprise-grade platforms, we deliver responsive and reliable solutions with<br />
              modern UI/UX and robust architecture.
            </p>

            <div className="hero-actions">
              <Button className="quote-button">
                Get Started <CaretRight size={20} weight="bold" />
              </Button>
            </div>
          </Col>

          <Col lg={5} className="hero-right mt-5 mt-lg-0">
            <div 
              className={`slideshow-frame ${isMaximized ? 'maximized' : 'minimized'}`}
              onClick={toggleMaximize}
            >
              {projects.map((project, index) => (
                <div 
                  key={project.id} 
                  className={`slide ${index === currentSlide ? 'active' : ''}`}
                  style={{ backgroundImage: `url(${project.image})` }}
                >
                  <div className="slide-overlay">
                     <div className="slide-info">
                        <h3>{project.title}</h3>
                        <p>{project.subtitle}</p>
                     </div>
                  </div>
                </div>
              ))}
              
              {!isMaximized && (
                <div className="slide-indicators">
                  {projects.map((_, index) => (
                    <span 
                      key={index} 
                      className={`indicator ${index === currentSlide ? 'active' : ''}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        setCurrentSlide(index);
                      }}
                    />
                  ))}
                </div>
              )}

              <div className="click-hint">
                 {isMaximized ? 'Click to Minimize' : 'Click to View Full'}
              </div>
            </div>

            <div className="stats-container">
              <div className="stat-card card-efficiency">
                <div className="stat-icon"><Target size={24} weight="duotone" color="#3b82f6" /></div>
                <div className="stat-info">
                  <span className="stat-label">Efficiency</span>
                  <span className="stat-value">94%</span>
                </div>
              </div>

              <div className="stat-card card-leads">
                <div className="stat-icon"><Users size={24} weight="duotone" color="#10b981" /></div>
                <div className="stat-info">
                  <span className="stat-label">New Leads</span>
                  <span className="stat-value">1,420 <small>+18%</small></span>
                </div>
              </div>

              <div className="stat-card card-revenue">
                <div className="stat-icon"><ChartLineUp size={24} weight="duotone" color="#8b5cf6" /></div>
                <div className="stat-info">
                  <span className="stat-label">Growth</span>
                  <span className="stat-value">$84k <small>+24%</small></span>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      
      <div className="hero-overlay"></div>
    </section>
  );
};

export default Hero;
